import { parseRuntime } from './impl-helper';

export const getIsAppFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const isApp = variable?.IS_MOOMOO || variable?.IS_NN;
    if (current.port.id === 'is-app-port') {
        return isApp;
    } else if (current.port.id === 'is-not-app-port') {
        return !isApp;
    }
    return false;
};
